/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestPayoutsRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetInterestPayoutsResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getInterestPayouts = (request: GetInterestPayoutsRequest, options?: CashRequestOptions) => post<GetInterestPayoutsRequest, GetInterestPayoutsResponse>("/2.0/cash/get-interest-payouts", request, {...options, rejectOnError: true })